module.exports = __webpack_public_path__ + "1bb12f4f/img/share-icon.f5a05c4d.svg";